import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import { UserType } from '../../types';
import { useAuthUserContext } from '../../providers';
import IconSearch from '../../images/common/icon_search.png';
import IconSearch2x from '../../images/common/icon_search@2x.png';
import IconMessage from '../../images/common/icon_message.png';
import IconMessage2x from '../../images/common/icon_message@2x.png';
import IconOfferrecord from '../../images/common/icon_offerrecord.png';
import IconOfferrecord2x from '../../images/common/icon_offerrecord@2x.png';
import IconProfile from '../../images/common/icon_profile.png';
import IconProfile2x from '../../images/common/icon_profile@2x.png';
import IconKyc from '../../images/common/icon_kyc.png';
import IconKyc2x from '../../images/common/icon_kyc@2x.png';
import IconDeposit from '../../images/common/icon_deposit.png';
import IconDeposit2x from '../../images/common/icon_deposit@2x.png';
import IconStar from '../../images/common/icon_star.png';
import IconStar2x from '../../images/common/icon_star@2x.png';
import IconForum from '../../images/common/icon_forum.png';
import IconForum2x from '../../images/common/icon_forum@2x.png';

const Header = () => {
  const authUser = useAuthUserContext().user;
  const isDonee = authUser?.userType === UserType.Donee;
  const isDonor = authUser?.userType === UserType.Donor;

  return (
    <header>
      <TopNav />
      <div className={ `mypagenav ${ isDonee ? 'pink' : '' }` }>
        <p><Link to="/mypage">マイページ</Link></p>
        <ul>
          { isDonee &&
            <li>
              <Link className="big" to="/search-result">
                <img
                  src={ IconSearch }
                  srcSet={ `${ IconSearch } 1x, ${ IconSearch2x } 2x` }
                  alt="ドナーを探す"
                />
                <span>ドナーを探す</span>
              </Link>
            </li>
          }
          <li>
            <Link className="big" to="/mypage/messages">
              <img
                src={ IconMessage }
                srcSet={ `${ IconMessage } 1x, ${ IconMessage2x } 2x` }
                alt="メッセージ"
              />
              <span>メッセージ</span>
            </Link>
          </li>
          <li>
            <Link to="/mypage/forum">
              <img
                src={ IconForum }
                srcSet={ `${ IconForum } 1x, ${ IconForum2x } 2x` }
                alt="掲示板"
              />
              <span>掲示板</span>
            </Link>
          </li>
          <li>
            <Link to="/mypage/kyc">
              <img
                src={ IconKyc }
                srcSet={ `${ IconKyc } 1x, ${ IconKyc2x } 2x` }
                alt="本人確認"
              />
              <span>本人確認</span>
            </Link>
          </li>
          { isDonor &&
            <>
              <li>
                <Link to="/mypage/profile">
                  <img
                    src={ IconProfile }
                    srcSet={ `${ IconProfile } 1x, ${ IconProfile2x } 2x` }
                    alt="プロフィール"
                  />
                  <span>プロフィール</span>
                </Link>
              </li>
              <li>
                <Link to="/mypage/checkups">
                  <img
                    src={ IconDeposit }
                    srcSet={ `${ IconDeposit } 1x, ${ IconDeposit2x } 2x` }
                    alt="検査結果登録"
                  />
                  <span>検査結果登録</span>
                </Link>
              </li>
            </>
          }
          <li>
            <Link to="/mypage/records">
              <img
                src={ IconOfferrecord }
                srcSet={ `${ IconOfferrecord } 1x, ${ IconOfferrecord2x } 2x` }
                alt="提供実績"
              />
              <span>提供実績</span>
            </Link>
          </li>
          <li>
            <Link to="/mypage/reviews">
              <img
                src={ IconStar }
                srcSet={ `${ IconStar } 1x, ${ IconStar2x } 2x` }
                alt="レビュー"
              />
              <span>レビュー</span>
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
